module.exports = __webpack_public_path__ + "a0dc829ae7a61fb3f684b69b546c4c25.MP3";